import { immediateToast } from "izitoast-react";
import { callAPI } from "../assets/Js/backendCommunication";
import projectSettings from "../assets/Js/projectSettings";
import addUserData from "../redux/actionCreators/addUserData";
import {
  getPlainToken,
  getUserData,
  setUserData,
} from "../assets/Js/tokenHandler";
import store from "../redux/store/store";

const userdData = getUserData();

export const getUserInfo = async () => {
  if (userdData?.Id) {
    let url = `${projectSettings.baseUrl}/users/${userdData.Id}`;
    let header = true;
    let type = "GET";
    let data = null;
    let plainToken = getPlainToken();

    let response = await callAPI(
      url,
      header,
      type,
      JSON.stringify(data),
      plainToken
    );
    if (response) {
      if (response.type === "error") {
        immediateToast("error", {
          message: `<div><strong>Something went wrong while getting user data.</strong></div>`,
        });
      } else if (response.type === "success") {
        setUserData({ ...response.data, Role: userdData.Role });
        store.dispatch(addUserData({ ...response.data, Role: userdData.Role }));
        response = "";
      }
    }
  }
};
